export default {
    'name': 'tiff',
    'width': '45',
    'height': '41',
    'viewBox': '0 0 41 45',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 12.2015V42H37.3333V0H11.8018L0 12.2015Z\' fill=\'#DBEFFF\'/><rect width=\'28\' height=\'15\' transform=\'translate(12.6667 20)\' fill=\'#006CFD\'/><path d=\'M18.3983 32V26.03H16.0683V25H22.0083V26.03H19.6583V32H18.3983ZM23.1639 32V25H24.4239V32H23.1639ZM26.3549 32V25H31.1749V26.03H27.6149V28.19H30.7249V29.22H27.6149V32H26.3549ZM32.4658 32V25H37.2858V26.03H33.7258V28.19H36.8358V29.22H33.7258V32H32.4658Z\' fill=\'white\'/>'
}
